import axios from 'axios'
import { getAuthHeader } from '../utils/axios.instances'

const aiAxios = axios.create({
  baseURL: process.env.VUE_APP_AI_SERVICE_URL
})

export default {
  setAuthToken (token) {
    aiAxios.defaults.headers.Authorization = getAuthHeader(token)
  },

  async generateHtml ({ prompt, html, lang, context, history }) {
    return new Promise((resolve, reject) => {
      aiAxios.post('/stc/ai/generate-html/', {
        prompt,
        html,
        language: lang,
        context,
        history: history || []
      }).then((res) => {
        resolve({ html: res.data.html, summary: res.data.summary, message: res.data.message })
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
